export const messages = {
  en: {
    businessTableHis: {
      search: {
        title: 'Search Condition',
        action: 'action',
        actionObj: 'actionObj',
        actionObjHis: 'actionObjHis',
        businessTypeCd: 'businessTypeCd',
        remark: 'remark',
        createTime: 'createTime',
        placeholder: 'Please enter businessTableHis name'
      },
      list: {
        title: 'businessTableHis List'
      },
      dialog: {
        addTitle: 'Add BusinessTableHis',
        editTitle: 'Edit BusinessTableHis',
        delTitle: 'Delete BusinessTableHis',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        hisId: 'hisId',
        action: 'action',
        actionObj: 'actionObj',
        actionObjHis: 'actionObjHis',
        businessTypeCd: 'businessTypeCd',
        remark: 'remark',
        createTime: 'createTime',
      },
      table: {
        hisId: 'hisId',
        action: 'action',
        actionObj: 'actionObj',
        actionObjHis: 'actionObjHis',
        businessTypeCd: 'businessTypeCd',
        remark: 'remark',
        createTime: 'createTime',
      },
      validate: {
        hisId: 'Please enter hisId',
        actionObj: 'Please enter actionObj',
        actionObjHis: 'Please enter actionObjHis',
        businessTypeCd: 'Please enter businessTypeCd',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add BusinessTableHis success'
      },
      edit: {
        success: 'Edit BusinessTableHis success'
      },
      delete: {
        success: 'Delete BusinessTableHis success',
        confirm: 'Are you sure to delete this businessTableHis?'
      },
      fetchError: 'Failed to fetch businessTableHis list'
    }
  },
  zh: {
    businessTableHis: {
      search: {
        title: '查询条件',
        action: '动作',
        actionObj: '表名',
        actionObjHis: '轨迹表名',
        businessTypeCd: '业务类型',
        remark: '备注',
        createTime: '创建时间',
        placeholder: '请输入业务轨迹名称'
      },
      list: {
        title: '业务轨迹'
      },
      dialog: {
        addTitle: '添加业务轨迹',
        editTitle: '编辑业务轨迹',
        delTitle: '删除业务轨迹',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        hisId: '历史ID',
        action: '动作',
        actionObj: '表名',
        actionObjHis: '轨迹表名',
        businessTypeCd: '业务类型',
        remark: '备注',
        createTime: '创建时间',
      },
      table: {
        hisId: '历史ID',
        action: '动作',
        actionObj: '表名',
        actionObjHis: '轨迹表名',
        businessTypeCd: '业务类型',
        remark: '备注',
        createTime: '创建时间',
      },
      validate: {
        hisId: '请输入历史ID',
        actionObj: '表名',
        actionObjHis: '轨迹表名',
        businessTypeCd: '业务类型',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加业务轨迹成功'
      },
      edit: {
        success: '编辑业务轨迹成功'
      },
      delete: {
        success: '删除业务轨迹成功',
        confirm: '确认删除该业务轨迹吗？'
      },
      fetchError: '获取业务轨迹列表失败'
    }
  }
}